module.exports = __webpack_public_path__ + "img/box67.1469e95c.png";